import SelectPaymentScreen from 'features/believe/makePayment/SelectPaymentScreen/SelectPaymentScreen';
import React from 'react';

export default function Page() {
  return <SelectPaymentScreen />;
}
